import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

const START_URL = 'https://start.stonewavetech.com'

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  await auth.waitForInit();
  if (auth.isAuthenticated()) return true;
  window.location.href = `${START_URL}?next=${encodeURIComponent(window.location.href)}`;
  return false;
};
